import styled from 'styled-components'

export const UserInfo = styled.div`
  margin: 0 0 20px 0 !important;
`
